






















































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { ProfitCollectionType } from '@/modules/profit/models/profit-collection.model'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import AdminProfitIndexPageTableRow from '@/modules/profit/components/admin/table/AdminProfitIndexPageTableRow.vue'
import { adminProfitIndexPageTableColumn } from '@/modules/profit/models/columns/admin-profit-index-page-table.column'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminProfitCreateDialog from '@/modules/profit/components/admin/AdminProfitCreateDialog.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'سودها'
  },
  metaInfo: {
    title: 'سودها'
  },
  components: {
    BaseButton,
    PaginationWithInput,
    TesTable,
    FilterRow
  }
})
export default class AdminProfitIndexPage extends mixins(QsSearchableMixin, QsPaginatableMixin) {
  @Prop() profits: ProfitCollectionType
  @Prop() sum: number

  private rowComponent = AdminProfitIndexPageTableRow

  private columns = adminProfitIndexPageTableColumn()

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع مدل',
      key: 'profitable_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.profits.profitable_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع سود',
      key: 'type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.profits.types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ',
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      keys: {
        from: 'created_at_from',
        to: 'created_at_to'
      },
      holder: 'انتخاب کنید',
      typeMode: false
    })
  ]

  @ProvideReactive()
  protected get fixedData() {
    return {
      types: this.profits.types,
      profitable_types: this.profits.profitable_types
    }
  }

  protected get model() {
    return this.profits
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private openCreateProfitDialog() {
    this.$q.dialog({
      component: AdminProfitCreateDialog,
      profitTypesInPersian: this.profits.types
    })
  }
}
